import React from 'react';
import { useLogin, Button, useNotify } from 'react-admin';
import { Stack, Card, Typography, CardContent, CardActions } from '@mui/material';
import { PodiyaAuthProvider } from '../types';

export const LoginPage = () => {
  const login = useLogin();

  const notify = useNotify();

  const surfaceForbiddenError = (error: any) => {
    if (error === 'Forbidden') {
      notify('Forbidden', { type: 'error' });
    }
  } 

  return (
    <main>
      <Stack height="90vh" alignItems='center' justifyContent='center'>
        <Card>
          <CardContent>
            <Typography variant="h5">Authorize</Typography>
          </CardContent>
          <CardActions>
            <Button label='Login with Facebook' size='large' onClick={() => login({ authProviderName: PodiyaAuthProvider.Facebook }).catch(surfaceForbiddenError)}></Button>
          </CardActions>
          <CardActions>
            <Button label='Sign in with Apple' size='large' onClick={() => login({ authProviderName: PodiyaAuthProvider.Apple }).catch(surfaceForbiddenError)}></Button>
          </CardActions>
        </Card>
      </Stack>
    </main>
  );
}
